import React from 'react';
import { CircleCheck, ArrowUpRight, MessageCircle, Headset, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Seo from '../components/Seo';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { FinalCTA } from '../components/Sections';
import { PRODUCTS } from '../mock';
import { Button } from '../components/ui/button';

const iconMap = { conversas: MessageCircle, helpdesk: Headset, coreai: Sparkles };

const ProductBlock = ({ p, idx }) => {
  const Icon = iconMap[p.id];
  const navigate = useNavigate();
  const reverse = idx % 2 === 1;
  return (
    <section id={p.id} className={`py-20 ${idx % 2 === 0 ? 'bg-white' : 'bg-[#FAF6F2]'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid lg:grid-cols-2 gap-12 items-center ${reverse ? 'lg:[&>*:first-child]:order-2' : ''}`}>
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-[#FFF1EA] px-3 py-1.5">
              <Icon size={14} className="text-[#FF5B24]" />
              <span className="text-[11px] font-bold text-[#FF5B24] uppercase tracking-widest">{p.tag}</span>
            </div>
            <h2 className="mt-4 text-3xl md:text-4xl font-extrabold text-[#0a0e27] leading-tight">{p.title}</h2>
            <p className="mt-4 text-slate-600 text-lg leading-relaxed">{p.description}</p>
            <ul className="mt-6 space-y-3">
              {p.bullets.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="mt-0.5 w-5 h-5 rounded-full bg-[#FFF1EA] flex items-center justify-center shrink-0">
                    <CircleCheck size={13} className="text-[#FF5B24]" />
                  </span>
                  <span className="text-sm text-slate-700">{b}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-3">
              <Button onClick={() => navigate('/contato')} className="btn-coral rounded-full h-12 px-6 text-sm font-semibold gap-1.5">
                Solicitar demonstração <ArrowUpRight size={16} />
              </Button>
              <Button variant="outline" onClick={() => navigate('/precos')} className="rounded-full h-12 px-6 text-sm font-semibold">
                Ver preços
              </Button>
            </div>
          </div>
          <div className="relative rounded-3xl bg-gradient-to-br from-[#0a0e27] via-[#1a1f4d] to-[#0a0e27] p-10 min-h-[380px] overflow-hidden">
            <div className="absolute -top-16 -right-16 w-64 h-64 bg-[#FF5B24]/30 rounded-full blur-3xl" />
            <div className="relative">
              <div className="w-16 h-16 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center">
                <Icon size={30} className="text-white" />
              </div>
              <div className="mt-6 text-white/60 text-sm font-medium uppercase tracking-widest">{p.tag}</div>
              <div className="mt-2 text-4xl font-extrabold text-white leading-tight">{p.title}</div>
              <div className="mt-6 grid grid-cols-2 gap-3">
                {p.bullets.slice(0, 4).map((b, i) => (
                  <div key={i} className="bg-white/5 border border-white/10 rounded-xl p-3">
                    <div className="flex items-center gap-1.5 text-[10px] text-[#FF5B24] font-semibold">
                      <CircleCheck size={12} /> INCLUÍDO
                    </div>
                    <div className="mt-1.5 text-xs text-white/90 leading-snug line-clamp-2">{b}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Produtos = () => (
  <>
    <Seo
      title="Produtos: Conversas, Helpdesk e CoreAI"
      description="Conheça a plataforma CoreDesk: atendimento omnichannel, helpdesk e agentes de IA (CoreAI) trabalhando juntos para vender e atender em escala, 24/7."
      path="/produtos"
    />
    <Header />
    <PageHero
      eyebrow="Nossos produtos"
      title="Uma plataforma. |Três superpoderes."
      subtitle="CoreDesk Conversas, Helpdesk e CoreAI trabalhando em conjunto para transformar seu atendimento em uma máquina de resultados."
    />
    {PRODUCTS.map((p, i) => <ProductBlock key={p.id} p={p} idx={i} />)}
    <FinalCTA />
    <Footer />
  </>
);

export default Produtos;
